import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {BracketsStageClickEvent} from "../models/events/brackets.stage-click-event";

export class BracketsStageClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.bracketsStageClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = BracketsStageClickEvent;
  }
}
